import React from 'react'
import styled from 'styled-components'
import {Errors, TextInput, validation, WithForm} from '@startlibs/form'
import {formFetch} from '@startlibs/utils'
import {Link} from '@startlibs/components'
import {Card, CardActionButton, CardHeader, SignInLayout} from '../components/SigninLayout'
import {SupportMessage} from '../components/SupportMessage'
import {FormattedMessage, useIntl} from "react-intl";
import {useToggle} from "@startlibs/core";
import {required} from '../lib/validation'

const LinkContainer = styled.div `
  margin-top: 1rem;
  text-align: center;
`

const onFailure = validation.responseFailure(({message, title, status}) =>
  (status === 404 && {
    username: [<React.Fragment><FormattedMessage
      defaultMessage="No account found using this username."
      description="Password recovery error message"
    /></React.Fragment>]
  })
)

export const PasswordRecovery = ({system}) => {
  const intl = useIntl()
  const successFeedback = useToggle()
  return <WithForm
    action={formFetch(`/pasapi/account/reset-password/init?locale=${intl.locale}`)}
    values={{systemId:system.systemId}}
    onFailure={onFailure}
    preValidation={validation.buildValidation({
      username: [required(intl)]
    })}
    onSuccess={(_,{email})=>successFeedback.openWith(email)}
  >{(form) =>
    <SignInLayout hideSupportMessage system={system}>
      <Card>
        <CardHeader>
          <h1><FormattedMessage
            defaultMessage="User password recovery"
            description="Password recovery title"
          /></h1>
          <p><FormattedMessage
            defaultMessage="Fill in below and a recovery link will be sent to your email"
            description="Password recovery instructions"
          /></p>
        </CardHeader>
          <TextInput
            path="username"
            label={intl.formatMessage({
              defaultMessage: "Username:",
              description: "Password recovery username input label"
            })}
            placeholder={intl.formatMessage({
              defaultMessage: "Enter your username",
              description: "Password recovery username input placeholder"
            })}
          />
          <Errors />
          {
            successFeedback.isOpen &&
            <ul className="successContainer">
              <li>
                <span><FormattedMessage
                  defaultMessage="Recovery link sent successfully to your email (<b>{email}</b>)."
                  description="Password recovery success message"
                  values={{
                    b: chunks => <b>{chunks}</b>,
                    email: successFeedback.isOpen
                  }}
                /></span>
                <span className="icon icon-x" onClick={() => { successFeedback.close(); form.setValue('username','') }}/>
              </li>
            </ul>
          }
          <CardActionButton type="submit" disabled={successFeedback.isOpen} isLoading={form.isLoading} highlight><FormattedMessage
            defaultMessage="Recover password"
            description="Password recovery submit button"
          /></CardActionButton>
          <LinkContainer><Link className="link" to="/" small><FormattedMessage
            defaultMessage="Back to sign in"
            description="Password recovery back to sign in link"
          /></Link></LinkContainer>
      </Card>
      <SupportMessage system={system}/>
    </SignInLayout>
  }
  </WithForm>
}